// extracted by mini-css-extract-plugin
export var bodySections = "_5o-8";
export var gray = "_5o-7";
export var green = "_5o-4";
export var iconContainer = "_5o-9";
export var iconWidgetContainer = "_5o-1";
export var phoneIcon = "_5o-2";
export var red = "_5o-5";
export var statusDot = "_5o-3";
export var widgetContainer = "_5o-0";
export var yellow = "_5o-6";